<template>
    <Card pageTitle="Customer">
        <AllowPermission :permission="$route.params.id ? PERMISSION_CODES.CMS_EDIT_CUSTOMER : PERMISSION_CODES.CMS_CREATE_CUSTOMER">
            <div>
                <div class="mb-3">
                    <Button noMargin @click="$router.push(ROUTE_PATHS.CUSTOMERS)">
                        <i class="fas fa-chevron-left"></i> Back To Customer List
                    </Button>
                    <Button
                        v-if="editMode"
                        borderOnly
                        class="ms-2"
                        @click="$router.push(customerLoyaltyPath($route.params.id))"
                    >
                        <i class="fas fa-star"></i> View Loyalty
                    </Button>
                </div>
                <UiState v-if="loading" type="loading" title="Loading customer" compact />
                <UiState
                    v-else-if="loadError"
                    type="error"
                    :message="loadError"
                    actionLabel="Try again"
                    compact
                    @action="fetchCustomerInitData"
                />
                <CustomerForm v-else :editMode="editMode" :editData="editData" :customerGroups="initData.customerGroups" /></div
        ></AllowPermission>
    </Card>
</template>
<script>
import CustomerForm from "../../components/CustomerForm.vue"
import Button from "../../components/UI/Button.vue"
import UiState from "../../components/UI/UiState.vue"
import { mapState } from "vuex"
import { http } from "@/utils/http"
import Card from "../../components/UI/Card.vue"
import AllowPermission from "../../components/layout/AllowPermission.vue"
import { PERMISSION_CODES } from "../../store/permission"
import { ROUTE_PATHS, customerLoyaltyPath } from "@/router/route-paths"

export default {
    data() {
        return {
            editMode: false,
            editData: null,
            loading: true,
            loadError: "",
            customers: [],
            initData: {
                customerGroups: [],
                warehouses: [],
            },
            PERMISSION_CODES,
            ROUTE_PATHS,
        }
    },
    async mounted() {
        if (this.$route.params.id) {
            this.editMode = true
        }
        await this.fetchCustomerInitData()
        // this.createFields = this.createFields.concat([
        //   createField("Profile Image", "profileImage", "image", false),
        // ]);
    },
    methods: {
        customerLoyaltyPath,
        async fetchCustomerInitData() {
            this.loading = true
            this.loadError = ""
            try {
                const res = await http.get("/customers/init", {
                    params: {
                        id: this.$route.params && this.$route.params.id,
                    },
                })
                this.editData = res.data.customer
                this.initData = res.data.result
            } catch (err) {
                console.log("error in fetching user init data", err)
                this.loadError = "Could not load customer details."
            }
            this.loading = false
        },
    },
    components: {
        Card,
        Button,
        CustomerForm,
        UiState,
        AllowPermission,
    },
    computed: {
        ...mapState("misc", ["showSidebar", "countries"]),
    },
}
</script>

<style lang="scss" scoped>
@import "../../assets/variables.scss";

/* Harmonize spacing using design tokens */
.mb-3 { margin-bottom: $sectionGap !important; }
</style>
